import { SystemEntity } from '@erp/shared-types';
import { Badge } from '@/components/ui/badge';
import {
  HoverCard,
  HoverCardTrigger,
  HoverCardContent,
} from '@/components/ui/hover-card';
import { cn } from '@/lib/utils';
import { PackageIcon } from '@phosphor-icons/react';
import { SystemEntityPreview } from '../preview-ui';
import { usePurchaseOrder } from '@/api/rpc/hooks/accounts-payable/usePurchaseOrders';

interface PurchaseOrderInlineProps {
  entityType: SystemEntity; // Required by inline component registry but not used - type is always INTERNAL_PURCHASE_ORDER
  entityId: string;
  className?: string;
}

export function PurchaseOrderInline({
  entityId,
  className,
}: PurchaseOrderInlineProps) {
  const { data: purchaseOrderData, isLoading } = usePurchaseOrder(entityId);

  const poNumber = isLoading
    ? 'Loading...'
    : purchaseOrderData?.purchaseOrder?.externalId ||
      purchaseOrderData?.purchaseOrder?.internalId?.toString() ||
      'Unknown';

  return (
    <HoverCard openDelay={200} closeDelay={200}>
      <HoverCardTrigger asChild>
        <div className="inline-block">
          <Badge
            variant="outline"
            className={cn('gap-1.5 cursor-pointer', className)}
          >
            <PackageIcon className="size-3" />
            <span>
              <span className="text-muted-foreground font-mono">PO</span>{' '}
              {poNumber}
            </span>
          </Badge>
        </div>
      </HoverCardTrigger>
      <HoverCardContent
        className="w-auto p-0 pointer-events-auto"
        align="start"
        side="bottom"
        sideOffset={2}
        onPointerEnter={(e) => e.stopPropagation()}
        onPointerLeave={(e) => e.stopPropagation()}
      >
        <SystemEntityPreview
          entityType={SystemEntity.INTERNAL_PURCHASE_ORDER}
          entityId={entityId}
        />
      </HoverCardContent>
    </HoverCard>
  );
}
